// src/components/ServicesSection.js
import React from 'react';
import '../styles/components/ServicesSection.css';
import { Link } from 'react-router-dom';
import { FaPlane, FaCalendarAlt, FaShieldAlt, FaHeadset, FaCreditCard, FaGlobe, FaSuitcase, FaMapMarkedAlt } from 'react-icons/fa';

const services = [
  {
    icon: <FaPlane />,
    title: "Flight Booking Services",
    content: "Book cheap flights online from 500+ airlines worldwide. Compare prices, get instant confirmation, and enjoy flexible cancellation policies.",
    id: 1
  },
  {
    icon: <FaCalendarAlt />,
    title: "Flexible Scheduling",
    content: "Flexible flight booking with date changes, last-minute reservations, and multi-city itineraries. Perfect for business and leisure travel.",
    id: 2
  },
  {
    icon: <FaShieldAlt />,
    title: "Travel Insurance & Protection",
    content: "Comprehensive travel insurance with medical coverage, trip cancellation protection, and 24/7 emergency assistance worldwide.",
    id: 3
  },
  {
    icon: <FaHeadset />,
    title: "24/7 Customer Support",
    content: "Professional customer support available 24/7 in 15+ languages. Get help with bookings, changes, and travel emergencies.",
    id: 4
  },
  {
    icon: <FaCreditCard />,
    title: "Secure Payment Options",
    content: "Safe online payments with SSL encryption, credit cards, PayPal, and flexible payment plans. PCI DSS certified security.",
    id: 5
  },
  {
    icon: <FaGlobe />,
    title: "Global Destinations",
    content: "Fly to 500+ destinations worldwide including popular cities and remote locations. Competitive prices on all international routes.",
    id: 6
  },
  {
    icon: <FaSuitcase />,
    title: "Package Deals & Combos",
    content: "Save money with flight and hotel packages. All-inclusive deals with accommodation, transfers, and activities included.",
    id: 7
  },
  {
    icon: <FaMapMarkedAlt />,
    title: "Travel Planning Services",
    content: "Expert travel planning with visa assistance, custom itineraries, and destination advice from certified travel consultants.",
    id: 8
  }
];

const ServicesSection = () => {
  return (
    <section id="services-section" className="services-section">
      <h2 className="services-header">Professional Travel Services | Flight Booking & Travel Support</h2>
      <div className="services-grid">
        {services.map((item, index) => (
          <div key={index} className="service-card">
            <div className="service-icon">{item.icon}</div>
            <h3 className="service-title">{item.title}</h3>
            <p className="service-content">{item.content}</p>
            <Link to={`/service/${item.id}`} className="read-more-link">Learn More</Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
